import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Api } from '@core/api/Api';
import type { SeriesOptionsType } from 'highcharts';
import { isEmpty, map, omitBy } from 'lodash';
import { TICKET_TYPE_COLOR } from './ticket-overview.constants';

@Injectable({
  providedIn: 'root',
})
export class TicketOverviewService {
  private readonly http = inject(HttpClient);

  fetchTickets(
    organization: string,
    term: string,
    sortField: string,
    sortOrder: string,
    page: number,
    blacklistStatus: string[],
    hasRemindersPaused: boolean,
    hasOpenStandingOrders: boolean,
  ) {
    return this.http.get(Api.TicketOverview.Overview(organization), {
      params: omitBy(
        {
          textQuery: term,
          sortField,
          sortOrder,
          page,
          blacklistStatus,
          hasRemindersPaused,
          hasOpenStandingOrders,
        },
        (v) => !v,
      ),
    });
  }

  getTicketLink(tenant: string, id: string, organization: string) {
    return this.http.get(Api.TicketOverview.Ticket(organization), {
      params: { tenant, id },
    });
  }

  getTenantLink(tenant: string, organization: string) {
    return this.http.get(Api.TicketOverview.Tenant(organization), {
      params: { tenant },
    });
  }

  fetchTenants(organization: string) {
    return this.http.get(Api.TicketOverview.Tenants(organization));
  }

  calcChartSeries(data: any): SeriesOptionsType[] {
    if (isEmpty(data)) return [];
    return map(data, (value, key) => {
      return {
        name: key,
        color: TICKET_TYPE_COLOR[key] || '#32323A',
        visible: true,
        data: [[value]],
        type: 'column',
      } as SeriesOptionsType;
    });
  }

  openKWH(response: any, id = '') {
    const maybeTicketId = id ? `&ticketId=${id}` : '';
    let url = `${response.baseUrl}loginByToken?token=${response.token}${maybeTicketId}`;
    if (!url.startsWith('http')) {
      url = `https://${url}`;
    }
    window.open(url, '_blank');
  }
}
